import React from "react";
import { StoryblokAsset } from "../../../interfaces/Storyblok/StoryblokAsset.interface";
import { StoryblokRichtext } from "storyblok-rich-text-react-renderer";
import Blok from "../../../interfaces/Storyblok/Blok.interface";
import ImageCarouselHero from "../../molecules/ImageCarouselHero/ImageCarouselHero.molecule";

interface ImageCarouselHeroBlokProps {
  carousel_cards: CarouselImageCard[];
  slide_duration?: number;
  enable_gradient?: boolean;
  text_alignment?: "left" | "center" | "right";
  auto_rotate?: boolean;
  height: string;
}

interface CarouselImageCard {
  background_image: StoryblokAsset;
  mobile_background: StoryblokAsset;
  heading: string;
  body: StoryblokRichtext;
  primary_cta: Blok[];
  secondary_cta?: Blok[];
}
const ImageCarouselHeroComponent: React.FC<ImageCarouselHeroBlokProps> = ({
  carousel_cards,
  slide_duration,
  enable_gradient,
  text_alignment,
  auto_rotate,
  height,
}) => {
  if (!carousel_cards || carousel_cards.length === 0) {
    return null;
  }

  return (
    <ImageCarouselHero
      cards={carousel_cards}
      slide_duration={slide_duration}
      enable_gradient={enable_gradient}
      text_alignment={text_alignment}
      auto_rotate={auto_rotate}
      height={height}
    />
  );
};

export default ImageCarouselHeroComponent;
